/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActiveTasksResponse } from '../models/ActiveTasksResponse';
import type { LLMEnum } from '../models/LLMEnum';
import { SportEnum } from '../models/SportEnum';
import type { Task } from '../models/Task';
import type { TaskInfo } from '../models/TaskInfo';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskService {
    /**
     * Get Task
     * @param taskId
     * @returns TaskInfo Successful Response
     * @throws ApiError
     */
    public static getTaskTaskPost(
        taskId: string,
    ): CancelablePromise<TaskInfo> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/',
            query: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Active Tasks
     * Returns a dictionary of active tasks per worker.
     * @returns ActiveTasksResponse Successful Response
     * @throws ApiError
     */
    public static getActiveTasksTaskActiveTasksGet(): CancelablePromise<ActiveTasksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/task/active_tasks',
        });
    }
    /**
     * Calculate Team Of The Week
     * @param areaOfInterestId
     * @param leagueId
     * @param matchDay
     * @param sendNotification
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static calculateTeamOfTheWeekTaskCalculateTeamOfTheWeekPost(
        areaOfInterestId?: (number | null),
        leagueId?: (number | null),
        matchDay?: (number | null),
        sendNotification: boolean = false,
    ): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/calculate_team_of_the_week',
            query: {
                'area_of_interest_id': areaOfInterestId,
                'league_id': leagueId,
                'match_day': matchDay,
                'send_notification': sendNotification,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Calculate Player Ratings
     * @param areaOfInterestId
     * @param leagueId
     * @param matchDay
     * @param matchId
     * @param skipAlreadyCalculated
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static calculatePlayerRatingsTaskCalculatePlayerRatingsPost(
        areaOfInterestId?: (number | null),
        leagueId?: (number | null),
        matchDay?: (number | null),
        matchId?: (number | null),
        skipAlreadyCalculated: boolean = false,
    ): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/calculate_player_ratings',
            query: {
                'area_of_interest_id': areaOfInterestId,
                'league_id': leagueId,
                'match_day': matchDay,
                'match_id': matchId,
                'skip_already_calculated': skipAlreadyCalculated,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Calculate Insider Score
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static calculateInsiderScoreTaskCalculateInsiderScorePost(): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/calculate_insider_score',
        });
    }
    /**
     * Calculate Inactive Player Statistics League
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static calculateInactivePlayerStatisticsLeagueTaskCalculateInactivePlayerStatisticsLeaguePost(): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/calculate_inactive_player_statistics_league',
        });
    }
    /**
     * Refresh Team Facts
     * @param areaOfInterestId
     * @param force
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static refreshTeamFactsTaskRefreshTeamFactsPost(
        areaOfInterestId?: (number | null),
        force: boolean = true,
    ): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/refresh_team_facts',
            query: {
                'area_of_interest_id': areaOfInterestId,
                'force': force,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Calculate Team Facts For League
     * @param leagueId
     * @param matchDay
     * @param llm
     * @param force
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static calculateTeamFactsForLeagueTaskCalculateTeamFactsForLeaguePost(
        leagueId: number,
        matchDay: number,
        llm: LLMEnum,
        force: boolean = true,
    ): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/calculate_team_facts_for_league',
            query: {
                'league_id': leagueId,
                'match_day': matchDay,
                'llm': llm,
                'force': force,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Brevo Refresh All Users
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static brevoRefreshAllUsersTaskBrevoRefreshAllUsersPost(): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/brevo_refresh_all_users',
        });
    }
    /**
     * Refresh Semi Static Data
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static refreshSemiStaticDataTaskRefreshSemiStaticDataPost(): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/refresh_semi_static_data',
        });
    }
    /**
     * Refresh Match Screen
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static refreshMatchScreenTaskRefreshMatchScreensPost(): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/refresh_match_screens',
        });
    }
    /**
     * Refresh Match Screen
     * @param matchId
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static refreshMatchScreenTaskRefreshMatchScreenMatchIdPost(
        matchId: number,
    ): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/refresh_match_screen/{match_id}',
            path: {
                'match_id': matchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Refresh Team Screen
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static refreshTeamScreenTaskRefreshTeamScreensPost(): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/refresh_team_screens',
        });
    }
    /**
     * Refresh Home Screen
     * @param areaOfInterestId
     * @param sport
     * @param date
     * @returns any Successful Response
     * @throws ApiError
     */
    public static refreshHomeScreenTaskRefreshHomeScreenPost(
        areaOfInterestId: number,
        sport: SportEnum,
        date: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/refresh_home_screen',
            query: {
                'area_of_interest_id': areaOfInterestId,
                'sport': sport,
                'date': date,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Refresh Home Screen Of Aoi
     * @param areaOfInterestId
     * @param sport
     * @returns any Successful Response
     * @throws ApiError
     */
    public static refreshHomeScreenOfAoiTaskRefreshHomeScreenOfAoiPost(
        areaOfInterestId: number,
        sport: SportEnum,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/refresh_home_screen_of_aoi',
            query: {
                'area_of_interest_id': areaOfInterestId,
                'sport': sport,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Refresh All Home Screens
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static refreshAllHomeScreensTaskRefreshAllHomeScreensPost(): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/refresh_all_home_screens',
        });
    }
    /**
     * Celery Backend Cleanup
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static celeryBackendCleanupTaskCeleryBackendCleanupPost(): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/celery_backend_cleanup',
        });
    }
    /**
     * Metric Consume Insider Stats
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static metricConsumeInsiderStatsTaskMetricConsumeInsiderStatsPost(): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/metric_consume_insider_stats',
        });
    }
    /**
     * Adjust Main Teams
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static adjustMainTeamsTaskAdjustMainTeamsPost(): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/adjust_main_teams',
        });
    }
    /**
     * Adjust Main Teams
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static adjustMainTeamsTaskSetCurrentMatchDayPost(): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/set_current_match_day',
        });
    }
    /**
     * Refresh Players And Ranking
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static refreshPlayersAndRankingTaskRefreshPlayersAndRankingPost(): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/refresh_players_and_ranking',
        });
    }
}
